export default __webpack_public_path__ + "static/media/bg-5.69c21d18.jpg";